import { Box, Paper, Tab, Tabs} from '@mui/material'
import { useState } from 'react'
import PropTypes from 'prop-types';
import AtsCandidateFilters from '../../ATSCandidate/CandidateFilter/AtsCandidateFilters';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import Base from '../../../../Base/views/Base';
import ArrowBackButton from '../../../../Base/views/ArrowBackButton';
import history from '../../../../../../history';
import { AtsJobPostModeAction } from '../../../../../../store/ATS/JobPost/Action';
import ResumeUploader from '../../ATSCandidate/ResumeUploader';
import ComingSoon from '../../../../Base/views/ComingSoon';
import DrivefileProcessor from '../../ATSCandidate/DrivefileProcessor';
import QuickSearchTab from './QuickSearch';

const AISuggestion = () => {
    const DownTime = false;
    const dispatch = useDispatch();
    const [value, setValue] = useState(0);
    const { currentJobData } = useSelector((state) => state.AtsReducer?.AtsJobPostReducer);
    const { job_id } = useParams()
    const id = atob(job_id);


    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", maxHeight: "87vh", overflowY: "auto" }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
        sessionStorage.removeItem("tagsSearch");
    };

    const handleBack = () => {
        dispatch(AtsJobPostModeAction({ job_mode: "edit", job_id: id, currentJobData: currentJobData }))
        history.push("/ats/manage-job")
    }
    return (
        <Base>
            <>
                <Box sx={{ borderRadius: "10px", overflowY: "auto", height: "calc(100vh - 85px)" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: "2px",}}>
                        <Box marginBottom={"-10px"}>
                            <ArrowBackButton onClick={handleBack} iconSize={18} />
                        </Box>
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" 
                            variant="scrollable"
                            orientation="horizontal"
                            allowScrollButtonsMobile={true}
                        >
                            <Tab label="Smart Search" {...a11yProps(0)} />
                            <Tab label="Manual Search" {...a11yProps(1)} />
                            <Tab label="Drive Upload" {...a11yProps(2)} />
                            <Tab label="Local Upload" {...a11yProps(3)} />
                        </Tabs>
                    </Box>
                    <TabPanel value={value} index={0}>
                        {/* <AISearch /> */}
                        <QuickSearchTab currentJobData={currentJobData} />
                    </TabPanel>
                    <TabPanel value={value} index={1} sx={{position: "relative"}}>
                        <AtsCandidateFilters ai={true} currentJobData={currentJobData} />
                    </TabPanel>
                    <TabPanel value={value} index={2} >
                        <DrivefileProcessor job_id={id} />
                    </TabPanel>
                    <TabPanel value={value} index={3} >
                        {DownTime ? <ComingSoon /> : <ResumeUploader id={id} />}
                    </TabPanel>
                </Box> 
            </>
        </Base >
    );
}
export default AISuggestion;